import React from 'react'

import Spinner from '~/components/Spinner'
import { getTransactionInfo } from '~/redux/uservideo/helpers'
import { fetchUserSubscription } from '~/redux/user/helpers'
import popup from '~/views/Popup/popup'
import ActiveSubscriptionInfo from './activeSubscription'
import PendingSubscriptionInfo from './pendingSubscription'
import DeferredSubscriptionInfo from './deferredSubscription'
import CancelledSubscriptionInfo from './cancelledSubscription'
import NoSubscriptionInfo from './noSubscription'
import SuspendedSubscriptionInfo from './suspendedSubscription'

class SubscriptionInfo extends React.Component {
  constructor() {
    super()
    this.state = {
      loading: true
    }
  }

  async componentDidMount() {
    const transaction = await getTransactionInfo(this.props.user.userId)
    this.setState({ transaction: !!transaction.data.records.length })

    try {
      const subscriptions = await fetchUserSubscription()
      this.setState({ loading: false })
      if (window.sessionStorage.getItem('openUpdatecard')){
        popup.updateStripePayment()
        window.sessionStorage.removeItem('openUpdatecard')
      }
    } catch (error) {
      this.setState({ loading: false })
    }
  }

  render() {
    const subscription = this.props.user && this.props.user.subscription
    const transaction = this.state.transaction

    if (this.state.loading) {
      return <Spinner/>
    } else if (!this.props.user.isSubscribed && !this.props.user.subscription) {
      return <NoSubscriptionInfo subscription={subscription} transaction={transaction}/>
    }

    switch(subscription.subscriptionInfo.subscriptionStatus) {
      case 'COMPLETED':
      case 'INACTIVE':
      case 'REFUNDED': {
        return <ActiveSubscriptionInfo subscription={subscription}/>
      }
      case 'PENDING': {
        return <PendingSubscriptionInfo subscription={subscription}/>
      }
      case 'SUSPENDED': {
        return <SuspendedSubscriptionInfo subscription={subscription} transaction={transaction}/>
      }
      case 'DEFERRED_CANCELLATION': {
        return <DeferredSubscriptionInfo subscription={subscription}/>
      }
      case 'CANCELLED': {
        return <CancelledSubscriptionInfo subscription={subscription}/>
      }
      default: {
        return <div></div>
      }
    }
  }
}

export default SubscriptionInfo;
